import { Component, inject } from '@angular/core';
import { LoadingService } from './loading.service';


@Component({
  selector: 'app-loading',
  templateUrl: './loading.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {
  protected loadingService = inject(LoadingService);
}
